import { HTTP_AP_AdvisorUser, HTTP_AP_AdvisorUserPermissionSettings } from '@api-new/userservice';
import { environment } from '@environments/environment';
import { createSelector } from '@ngrx/store';
import { PROFILE_NAME_PLACEHOLDER } from '../../constants/constants';
import { AppStateModel, UserState } from '../../models/app-state.model';

export const selectUserState = (state: AppStateModel): UserState => state.currentUser;

export const selectUser = createSelector(selectUserState, (state: UserState): HTTP_AP_AdvisorUser => state.entity ?? null);

export const selectIsUserLoading = createSelector(selectUserState, (state: UserState): boolean => state.loading);

export const selectIsUserLoaded = createSelector(selectUserState, (state: UserState): boolean => state.loaded);

export const selectIsUserPasswordReset = createSelector(selectUserState, (state: UserState): boolean => state.metadata.passwordReset);

export const selectUserDisplayName = createSelector(selectUser, (user: HTTP_AP_AdvisorUser): string => {
  if (user == null || user.displayName == null) {
    return PROFILE_NAME_PLACEHOLDER;
  }
  return user.displayName;
});

export const selectUserPermissions = createSelector(
  selectUserState,
  (state: UserState): HTTP_AP_AdvisorUserPermissionSettings => state?.entity?.advisorUserPermissionSettings,
);

export const selectRedirectUrlAfterSignIn = createSelector(
  selectUserState,
  (state: UserState): string => state?.metadata?.redirectUrlAfterSignIn || null,
);

export const selectUserCompanyId = createSelector(selectUserState, (user: UserState): string => user.entity?.companyId);

// LENDER COMPANY SPECIFIC DASHBOARD
export const BCM_COMPANY_ID = environment.production ? '295' : '249';
export const HBS_COMPANY_ID = environment.production ? '529' : '308';
export const selectHasUserCompanyCustomDashboard = createSelector(selectUser, (user: HTTP_AP_AdvisorUser): boolean =>
  [BCM_COMPANY_ID, HBS_COMPANY_ID].includes(user?.companyId),
);
